import React from 'react';
import { Button } from 'reactstrap';

const Mobile = (props) => {
    const {
        TitlePath,
        DatePath,
        DescriptionPath,
        activeFilter,
        usage_js,
        getPreview,
        submitting,
        handleChangeFilter,
        deletePath,
        onSubmit,
        openFeedPreviewModal,
        renderFrame,
        loadScripts,
    } = props;
    const resetAll = () => {
        TitlePath && deletePath('Title', true);
        DescriptionPath && deletePath('Description');
        DatePath && deletePath('Date');
        handleChangeFilter('Title');
    };
    return (
        <div className="preview" style={{ width: '100%' }}>
            <div className="preview-mobile_header">
                {usage_js === false && (
                    <div className="loadScripts-mobile">
                        Missing content?{' '}
                        <div onClick={(e) => loadScripts(e)}>
                            Load page scripts
                        </div>
                    </div>
                )}
                <div className="mobile-btns">
                    {(TitlePath || DescriptionPath || DatePath) && (
                        <Button style={{ marginRight: '5px' }} className="btn btn-secondary" onClick={resetAll}>
                            <i style={{ fontSize: 20 }} className="fas fa-trash-alt" />
                        </Button>
                    )}
                    {/*resource_exists === 'absent' && (
                        <Button 
                            onClick={(e) => loadScripts(e)}
                            style={{ marginRight: '5px' }}
                            className="typical-button"
                        >
                            Load page scripts
                        </Button>
                    )*/}
                    {TitlePath && (
                        <Button 
                            onClick={() => openFeedPreviewModal(getPreview)} 
                            style={{ marginRight: '5px' }} 
                            className="typical-button"
                        >
                            Preview feed
                        </Button>
                    )}
                    <Button 
                        onClick={(e) => onSubmit(e)} 
                        disabled={!TitlePath} 
                        className="calltoaction-button preview-mobile_generate "
                        style={!TitlePath ? { backgroundColor: '#c8ced3', borderColor: '#c8ced3' } : {}}
                    >
                        {submitting ? <i className="fa fa-spinner fa-spin" /> : 'Generate'}
                    </Button>
                </div>
                <div className="preview-tabs">
                    <div 
                        onClick={() => handleChangeFilter('Title')} 
                        className={`${TitlePath && 'completed'} ${activeFilter === 'Title' && 'active'}`}
                    >
                        Title
                    </div>
                    <div 
                        onClick={() => handleChangeFilter('Description')} 
                        className={`${DescriptionPath && 'completed'} ${activeFilter === 'Description' && 'active'}`}
                    >
                        Abstract
                    </div>
                    <div 
                        onClick={() => handleChangeFilter('Date')} 
                        className={`${DatePath && 'completed'} ${activeFilter === 'Date' && 'active'}`}
                    >
                        Date
                    </div>
                </div>
            </div>
            <div className="preview-mobile_main">{renderFrame()}</div>
        </div>
    );
};

export default Mobile;
